module.exports = __webpack_public_path__ + "img/hr-green-croton-02.e97da23d.png";